import { Link } from 'react-router-dom';
import type { BlogArticle } from '@/mocks/blog';

function BlogCard({ article }: { article: BlogArticle }) {
  return (
    <Link
      to={`/blog/${article.slug}`}
      className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-400/40 transition-all duration-300 flex flex-col h-full"
    >
      <div className="relative h-48 md:h-52 w-full overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-semibold bg-background-50/90 backdrop-blur-sm text-primary-400">
          {article.category}
        </span>
      </div>

      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {article.readTime} min
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {article.views.toLocaleString('fr-FR')}
          </span>
          <span>{article.publishedAt}</span>
        </div>

        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-50 mb-2 leading-snug group-hover:text-primary-400 transition-colors">
          {article.title}
        </h3>

        <p className="text-sm text-foreground-400 leading-relaxed line-clamp-3 mb-4 flex-1">
          {article.excerpt}
        </p>

        <div className="mt-auto pt-4 border-t border-background-200/70 flex items-center gap-3">
          {article.authorImage ? (
            <img
              src={article.authorImage}
              alt={article.author}
              className="w-8 h-8 rounded-full object-cover shrink-0"
            />
          ) : (
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/10 shrink-0">
              <span className="text-xs font-semibold text-primary-400">
                {article.author.charAt(0)}
              </span>
            </div>
          )}
          <div className="min-w-0">
            <span className="block text-xs font-medium text-foreground-400 truncate">{article.author}</span>
            <span className="block text-xs text-foreground-500 truncate">{article.authorRole}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default BlogCard;